import request from '@/utils/request'

/*
data: Form Data
*/
export function addFolder (data) {
  return request({
    url: '/jwt/folder/add',
    method: 'post',
    data
  })
}

export function listMyFolders (data) {
  return request({
    url: '/jwt/folder/list-mine',
    method: 'post',
    data
  })
}

export const getFolderByTitle = (data) => {
  return request({
    url: '/jwt/folder/detail-by-title',
    method: 'post',
    data
  })
}

export function getFolder (data) {
  return request({
    url: '/jwt/folder/detail',
    method: 'post',
    data
  })
}

export function removeFolder (data) {
  return request({
    url: '/jwt/folder/remove-this',
    method: 'post',
    data
  })
}

export function updateFolder (data) {
  return request({
    url: '/jwt/folder/update-this',
    method: 'post',
    data
  })
}

export function matchFolderTags ({ tags }) {
  return request({
    url: '/jwt/folder/match-tags',
    method: 'post',
    data: {
      tags
    }
  })
}

export const queryFolder = ({ query }) => {
  return request({
    url: '/jwt/folder/query-tags',
    method: 'post',
    data: {
      tagQuery: query
    }
  })
}
